import React from 'react'
import { Link } from 'react-router-dom'
import { cn } from 'utils'
import MobileMenuNotification from '../../MobileMenuNotification/MobileMenuNotification'
import Notifications from '../../Notifications/Notifications'

import styles from '../Header.module.scss'

interface OwnProps {
  onMenuClick: () => void
  onFriendsClick: () => void
  isOpened: boolean
  isUserLoggedIn: boolean
  isOrganizer: boolean
  unreadMessagesCount: number
  openUnreadMessagesModal: () => void
  isNotificationsOpened: boolean
  setIsNotificationsOpened: React.Dispatch<React.SetStateAction<boolean>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
}

const MobileMenuNew = ({
  onMenuClick,
  onFriendsClick,
  isOpened,
  isOrganizer,
  isUserLoggedIn,
  unreadMessagesCount,
  openUnreadMessagesModal,
  isNotificationsOpened,
  setIsNotificationsOpened,
  page,
  setPage,
}: OwnProps) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault()
    onMenuClick()
  }

  const handleFriendsClick = () => {
    onFriendsClick()
  }

  const handleUnreadMessagesClick = () => {
    openUnreadMessagesModal()
  }


  return (
    <nav className={styles.mobileMenu}>
      <div className="container-fluid h-100">
        <div className="row align-items-center h-100">
          <div className="col-auto p-l-7">
            <a className={cn(styles.mobileMenu__button, isOpened && styles.mobileMenu__button__opened)} href="#" onClick={handleClick}>
              <div />
              <div />
              <div />
            </a>
          </div>
          <div className={cn('col', !isUserLoggedIn && 'p-r-30 p-l-0')}>
            <div className="row justify-content-center">
              <Link to="/" className={styles.mobileMenu__logo} />
            </div>
          </div>
          <div className="col-auto p-r-35">
            <div className="row justify-content-end">
              {isUserLoggedIn && (
                <>
                  <MobileMenuNotification
                    className={styles.mobileMenu__notification__messages}
                    onClick={handleUnreadMessagesClick}
                    displayValue
                    value={unreadMessagesCount}
                  />
                  <Notifications
                    isOpened={isNotificationsOpened}
                    setIsOpened={setIsNotificationsOpened}
                    notificationIconType="mobile"
                    page={page}
                    setPage={setPage}
                  />
                  {!isOrganizer && (
                    <MobileMenuNotification
                      className={styles.mobileMenu__notification__cart}
                      onClick={() => {
                        window.location.href = '/cart'
                      }}
                      displayValue={false}
                    />
                  )}
                </>
              )}
              <MobileMenuNotification 
                className={styles.mobileMenu__notification__friends} 
                onClick={handleFriendsClick} 
                displayValue={false} 
              />
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default MobileMenuNew
